export default {"src":"/_next/static/media/no_last_registers.b6c7c2c9.svg","height":152,"width":220};